import { FC } from "react";
import cls from "classnames";
import useWork from "@/hooks/useWork";
import styles from "./index.module.scss";

const BtnAdd: FC<{ isLeftPanel: boolean }> = ({ isLeftPanel }) => {
  const { add } = useWork();

  const handleAdd = () => {
    add();
  };

  return (
    <button
      onClick={handleAdd}
      className={cls({ [styles.button]: true, [styles.large]: isLeftPanel })}
    >
      <i className={styles.add} />
      新建项目
    </button>
  );
};

export default BtnAdd;
